export default __webpack_public_path__ + "static/media/1202.bb9150c1.png";